export default function colorResponseTime(time) {
  if (time < 1) return "green";
  if (time < 3) return "teal";
  if (time < 5) return "yellow";
  if (time < 10) return "orange";
  return "red";
}
